import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_sm_text = _resolveComponent("sm-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_sm_badge = _resolveComponent("sm-badge")!
  const _component_v_system_bar = _resolveComponent("v-system-bar")!

  return (_openBlock(), _createBlock(_component_v_system_bar, {
    app: "",
    color: "#ffffff",
    height: _ctx.STYLES.APP_BAR_HEIGHT,
    class: "sm__system-bar"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_img, {
        alt: "smooth-e Logo",
        src: "/resources/system-bar/smooth-e__color_logotype_name.png",
        width: 240,
        height: 40,
        position: "left",
        class: "mr-2 ml-4 my-2"
      }),
      (_ctx.firstBtn)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            variant: "text",
            height: 24,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click-first-btn'))),
            class: "sm__system-bar-btn ml-5",
            "prepend-icon": _ctx.firstBtn.icon
          }, {
            prepend: _withCtx(() => [
              _createVNode(_component_v_icon, {
                size: "x-large",
                class: "sm__system-bar-btn-icon",
                style: {"opacity":"1"}
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_sm_text, {
                text: _ctx.firstBtn.text,
                format: "sm__btn-mini",
                color: "black"
              }, null, 8, ["text"])
            ]),
            _: 1
          }, 8, ["prepend-icon"]))
        : _createCommentVNode("", true),
      (_ctx.secondBtn)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 1,
            variant: "text",
            height: 24,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('click-second-btn'))),
            class: "sm__system-bar-btn",
            "prepend-icon": _ctx.secondBtn.icon
          }, {
            prepend: _withCtx(() => [
              _createVNode(_component_sm_badge, {
                dot: "",
                visible: _ctx.secondBadgeVisible
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    size: "x-large",
                    class: "sm__system-bar-btn-icon",
                    style: {"opacity":"1"}
                  })
                ]),
                _: 1
              }, 8, ["visible"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_sm_text, {
                text: _ctx.secondBtn.text,
                format: "sm__btn-mini",
                color: "black"
              }, null, 8, ["text"])
            ]),
            _: 1
          }, 8, ["prepend-icon"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["height"]))
}